import React from 'react';
import ShareFormTextarea, {
  ShareFormTextareaProps,
} from 'components/ShareForm/ShareFormTextarea';
import { socialShareModalBlock as block } from '../utils';

export type SocialShareModalAICaptionsFieldProps = {
  inputProps: ShareFormTextareaProps;
};

const SocialShareModalAICaptionsField: React.FC<SocialShareModalAICaptionsFieldProps> = ({
  inputProps,
}) => {
  return (
    <ShareFormTextarea
      {...inputProps}
      controlClassName={block('ai-captions-field-control')}
      className={block('ai-captions-field')}
    />
  );
};

export default SocialShareModalAICaptionsField;
